var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnaProfilePic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 100
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9199,
    cy: 50,
    rx: 48,
    ry: 50,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9199,
    cy: 50,
    rx: 48,
    ry: 50,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.4498 71.5636L-1.5507 70.7784C-0.917362 70.7153 -0.318297 71.09 -0.0738277 71.7021L5.88986 86.6481C6.2641 87.5863 5.65978 88.6334 4.68853 88.7302L-3.53067 89.5476C-4.1752 89.6113 -4.78226 89.2233 -5.01851 88.5963L-10.6621 73.6179C-11.0137 72.6843 -10.4092 71.6595 -9.4498 71.5636Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.56335 98.2482C-1.70226 98.3729 -8.34246 91.3055 -11.8882 87.3897L-8.33652 85.1387L11.0561 97.8141L-1.56335 98.2482Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2921 14.9803C52.4178 14.3623 53.9988 7.74657 63.8598 9.17243C63.8598 9.17243 58.9407 8.89744 57.739 10.9525C57.739 10.9525 61.4768 8.82132 64.0015 10.1825C66.5284 11.5434 67.2824 16.703 67.0311 18.3094C66.7775 19.9156 64.4287 24.8157 62.6603 24.9477C61.9886 24.9979 61.2575 24.8192 60.604 24.5783C60.9331 25.3935 61.2415 26.2831 61.5134 27.2637C64.0266 36.331 58.6277 43.7692 55.4679 42.2668C53.4413 41.3031 52.2098 44.9672 52.2098 44.9672L34.4854 23.8394C34.4854 23.8394 44.7912 8.88769 52.2921 14.9803Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1523 71.6364C36.465 73.3066 39.3643 74.6839 43.004 75.5583C56.6463 78.8401 61.8738 66.835 63.8387 58.5944C61.9766 57.4859 60.2265 57.2416 59.2166 57.116C58.2296 56.9949 57.1923 56.9145 56.3333 56.8702C54.8025 55.6485 52.52 50.6485 52.0151 42.8857L51.373 43.0649L40.621 46.1288C40.621 46.1288 41.1122 49.6872 41.3544 53.0508C41.5417 55.6825 41.5714 58.1978 41.0916 58.8132C40.2531 59.0026 39.7482 59.1265 39.7482 59.1265C39.7482 59.1265 39.7482 59.1303 39.7436 59.137C39.5997 59.3834 36.4787 64.7243 34.1523 71.6364Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6211 46.1308C40.6211 46.1308 41.1146 49.6864 41.3545 53.0529C47.4457 52.4177 50.2719 46.3796 51.3732 43.0674L40.6211 46.1308Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8024 49.472C38.8024 49.472 53.2604 48.6416 52.6252 39.2748C51.99 29.9083 53.4272 23.4927 44.1693 23.6271C34.9105 23.7612 33.3615 27.4672 32.8431 30.6472C32.3249 33.8276 35.0239 49.4471 38.8024 49.472Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9145 25.4082C34.9525 22.4242 36.6828 22.9162 37.6858 23.6926C45.2689 18.5851 50.814 24.8853 50.814 24.8853C52.2443 31.5334 57.1634 35.0354 57.1634 35.0354C57.1634 35.0354 54.6478 36.9247 48.4676 35.7534C46.5804 35.3954 44.8302 34.1474 43.3086 32.5891C46.0594 36.6916 49.6145 39.5295 49.6145 39.5295C42.1274 36.5826 38.4923 26.3038 38.1267 25.2153C37.3019 26.1057 35.6866 28.0261 35.2783 29.8206C34.7229 32.2594 34.7371 37.1935 33.3514 37.1288C33.3514 37.1288 29.8577 29.883 32.9145 25.4082Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.461 58.3741C36.461 58.3741 60.0169 52.4202 70.2572 61.2149L62.1888 98.3743L65.1393 135.536L19.0737 123.949C19.0737 123.949 20.3699 119.246 29.2032 106.741C38.0375 94.2352 34.1943 75.8921 36.461 58.3741Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4326 82.4122C72.297 91.3532 67.7481 102.294 66.1236 108.184C66.1236 108.184 68.8379 128.63 66.2447 134.244C65.9523 134.885 65.5867 135.332 65.1389 135.534C55.5337 139.89 18.1272 135.66 16.5482 123.097C15.9742 118.532 30.7964 102.475 31.66 100.527C32.019 99.7206 32.4003 97.1082 30.663 91.6941C28.1995 99.601 23.6503 108.731 19.074 110.288C14.0452 112.001 -5.83953 96.5739 -5.83953 96.5739C-5.83953 96.5739 -5.95422 94.6999 -3.44053 92.9275C-1.82406 91.7876 1.88867 91.4034 1.88867 91.4034L14.6041 97.3275C16.1997 94.4849 20.1754 74.8179 24.6141 65.9402C27.9514 59.2665 36.8627 58.2997 36.8627 58.2997C36.8627 58.2997 40.5708 64.4242 49.5408 63.5555C58.5085 62.687 60.149 56.9707 60.149 56.9707C60.149 56.9707 68.1045 58.0716 70.5538 60.1305C70.9787 60.4875 74.9245 70.6983 73.4326 82.4122Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1243 108.184C66.1243 108.184 68.8386 128.63 66.2454 134.244C59.2471 130.587 50.1264 122.693 52.9023 110.358C56.935 92.4366 73.4332 82.4121 73.4332 82.4121C72.2977 91.3531 67.7487 102.294 66.1243 108.184Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1494 56.9707C60.1494 56.9707 71.7037 58.3977 74.8841 63.5555C78.9052 70.0772 88.2513 86.1375 87.9451 92.6827C87.9451 92.6827 87.5549 95.9348 64.9208 116.26C64.9208 116.26 58.7441 114.795 63.75 111.788C63.75 111.788 77.5092 91.3774 78.9167 90.0862L69.4303 79.5912L60.1494 56.9707Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-11.1694 71.7261L-3.27007 70.9404C-2.63674 70.8776 -2.03745 71.2523 -1.79343 71.8644L4.17048 86.8106C4.54472 87.7483 3.94063 88.796 2.96938 88.8923L-5.25005 89.7099C-5.89458 89.7739 -6.50164 89.3857 -6.73811 88.7581L-12.3812 73.7805C-12.7331 72.8463 -12.1283 71.8213 -11.1694 71.7261Z",
    fill: "#2B478B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnaProfilePic);
export default __webpack_public_path__ + "static/media/anna-profile-pic.8ff8b9014f0d8c7e21bcd2b08090d482.svg";
export { ForwardRef as ReactComponent };